import React from "react";
import { withRouter } from "react-router-dom";

import Firebase, { METHODS } from "../Utils/Firebase";
import { snapShotToArray } from "../Utils/helpers";

import LoaderModule from "../Components/Loader";
import VideoPlayer from "../Components/VideoPlayer";
import RadarChart from "../Components/RadarChart";
import Comment from "../Components/Comment";

const style = {
  layout: { marginTop: "100px" }
};

const Radar = ({ videoId }) => (
  <Firebase
    refPath={`/videos/${videoId}/evaluations/`}
    method={METHODS.ON}
    renderSuccess={(snapshot) => {
      const feedback = snapShotToArray(snapshot);
      let contenuSum = 0;
      let organisationSum = 0;
      let delivranceSum = 0;
      let effectSum = 0;
      feedback.forEach(function(feed) {
        contenuSum += parseInt(feed.contenu, 10);
        organisationSum += parseInt(feed.organisation, 10);
        delivranceSum += parseInt(feed.delivrance, 10);
        effectSum += parseInt(feed.effect, 10);
      });
      let contenuAvg = contenuSum / feedback.length;
      let organisationAvg = organisationSum / feedback.length;
      let delivranceAvg = delivranceSum / feedback.length;
      let effectAvg = effectSum / feedback.length;
      let globalAvg =
        Math.round(
          ((contenuAvg + organisationAvg + delivranceAvg + effectAvg) / 4) * 10
        ) / 10;
      const data = [
        globalAvg,
        contenuAvg,
        organisationAvg,
        delivranceAvg,
        effectAvg
      ];

      return (
        <div>
          <RadarChart data={data} />
          <p>
            Note globale :{" "}
            <span style={{ fontWeight: "600" }}>{globalAvg} / 5</span>
          </p>
        </div>
      );
    }}
    renderError={(error) => {
      return <pre>{JSON.stringify(error)}</pre>;
    }}
    renderPending={() => {
      return null;
    }}
  />
);

const Commentaires = ({ videoId, user }) => (
  <Firebase
    refPath={`/videos/${videoId}/evaluations/`}
    method={METHODS.ON}
    renderSuccess={(snapshot) => {
      const feedback = snapShotToArray(snapshot);
      let impressionsArray = [];
      feedback.forEach(function(feed) {
        impressionsArray.push({
          evalId: feed.id,
          impressions: feed.impressions,
          isAnonyme: feed.isAnonyme,
          userName: feed.userName,
          userMail: feed.userMail,
          createdAt: feed.createdAt
        });
      });

      return (
        <div>
          <h5>Commentaires :</h5>
          <ol>
            {impressionsArray.map(
              (
                {
                  evalId,
                  impressions,
                  isAnonyme,
                  userName,
                  userMail,
                  createdAt
                },
                i
              ) => (
                <Comment
                  key={i}
                  evalId={evalId}
                  impressions={impressions}
                  isAnonyme={isAnonyme}
                  userName={userName}
                  userMail={userMail}
                  createdAt={createdAt}
                  videoId={videoId}
                  pitchOwner={user}
                />
              )
            )}
          </ol>
        </div>
      );
    }}
    renderError={(error) => {
      return <pre>{JSON.stringify(error)}</pre>;
    }}
    renderPending={() => {
      return null;
    }}
  />
);

const Feedback = ({ videoId, user }) => (
  <div style={style.layout}>
    <Firebase
      refPath={`/videos/${videoId}`}
      method={METHODS.ON}
      renderSuccess={(snapshot) => {
        const pitchInfo = snapshot.val();
        return (
          <div>
            <h2>{pitchInfo.title}</h2>
            <h4>{pitchInfo.description}</h4>
            <div>
              <VideoPlayer
                src={pitchInfo.transcodedUrl}
                videoId={videoId}
                owner={pitchInfo.userId}
                user={user}
              />
              <Radar videoId={videoId} />
            </div>
            <Commentaires videoId={videoId} user={user} />
          </div>
        );
      }}
      renderError={(error) => {
        return <pre>{JSON.stringify(error)}</pre>;
      }}
      renderPending={() => {
        return <LoaderModule />;
      }}
    />
  </div>
);
export default withRouter(Feedback);
